var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { BaseWidgetConfiguration } from "./base-widget";
import { EntityTypeConfigurationHelper } from "../models/basics/basics.models";
var TextWidgetConfiguration = /** @class */ (function (_super) {
    __extends(TextWidgetConfiguration, _super);
    function TextWidgetConfiguration(entityTypeConfigurationHelper) {
        var _this = _super.call(this, entityTypeConfigurationHelper) || this;
        _this.title = "";
        _this.description = "";
        _this.color = "000000";
        _this.items = [];
        _this.fontSizes = [];
        _this.fontSize = "22px";
        _this.populateFontSizes();
        return _this;
    }
    TextWidgetConfiguration.prototype.add = function () {
        this.items.push({
            text: "",
            subtitle: ""
        });
    };
    TextWidgetConfiguration.prototype.remove = function (index) {
        if (index > -1)
            this.items.splice(index, 1);
    };
    TextWidgetConfiguration.prototype.populateFontSizes = function () {
        for (var i = 14; i <= 50; i += 2) {
            this.fontSizes.push(i + "px");
        }
    };
    TextWidgetConfiguration.prototype.getModel = function (self) {
        return {
            components: this.items,
            description: this.description,
            title: this.title,
            color: this.color,
            fontSize: this.fontSize
        };
    };
    TextWidgetConfiguration.prototype.setModel = function (model) {
        this.title = model.title ? model.title : "";
        this.items = model.components ? model.components : [];
        this.description = model.description;
        this.color = model.color;
        this.fontSize = model.fontSize;
    };
    TextWidgetConfiguration.prototype.entityTypeChanged = function () {
    };
    TextWidgetConfiguration = __decorate([
        transient(),
        autoinject(),
        __metadata("design:paramtypes", [EntityTypeConfigurationHelper])
    ], TextWidgetConfiguration);
    return TextWidgetConfiguration;
}(BaseWidgetConfiguration));
export { TextWidgetConfiguration };
